import { Injectable } from '@angular/core';
import { LogLevel, LogService } from '@core/logging';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import menu from 'assets/data/menu.json';
import { MenuService } from './menu.service';
import { TranslateLangService } from './translate-lang.service';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(
    private logService: LogService,
    private menuService: MenuService,
    private translateLangService: TranslateLangService,
    _store: Store
  ) {}

  public async load(): Promise<void> {
    try {
      this.logService.Level = environment.logLevel || LogLevel.All;
      await this.translateLangService.load();

      this.menuService.setMenu(menu.sideNav);
      this.menuService.setMetaMenu(menu.metaNav);
    } catch (error) {
      this.logService.error('Failed to load startup data.', error);
    }
  }
}
